import React, { useState } from "react";
import AppContainer from "../../components/containers/AppContainer";
import { Divider, Stack, Typography, Box, MenuItem } from "@mui/material";
import { APP_ICONS } from "../../assets";
import DashboardChart from "./../../components/charts/DashboardChart";
import SelectInput from "../../components/select";

const RenderProfit = ({ icon, title, value }) => {
  return (
    <Stack direction={"row"} alignItems={"center"} gap={3}>
      <img src={icon} width={55} height={55} />
      <Typography variant="body1" fontWeight={600}>
        {title}
      </Typography>
      <Typography fontSize={"1.125rem"} fontWeight={600} ml={3}>
        +\- {value}%
      </Typography>
    </Stack>
  );
};

const PlatformChart = ({ data }) => {
  const [filter, setFilter] = useState("yearly");
  return (
    <AppContainer>
      <Stack
        px={2.5}
        py={3}
        direction={{ md: "row" }}
        alignItems={{ md: "center" }}
        justifyContent={"space-between"}
        gap={2}
      >
        <Stack>
          <Typography variant="h5" fontWeight={600}>
            Platform Earning Chart
          </Typography>
          <Typography fontSize={"1.125rem"} color={"customColor.dustyGray"}>
            Yearly Earning Overview
          </Typography>
        </Stack>
        {/* <Stack
          direction={{ sm: "row" }}
          alignItems={{ md: "center" }}
          gap={{ xs: 2, md: 4 }}
        >
          <RenderProfit
            icon={APP_ICONS.profitBgIconGreen}
            title={"Net Profit"}
            value={"00.00"}
          />
          <RenderProfit
            icon={APP_ICONS.profitBgIconBlue}
            title={"Net Profit"}
            value={"00.00"}
          />
        </Stack> */}
      </Stack>
      <Divider sx={{ mb: 2, borderColor: "#BDBDBD" }} />
      <Stack px={2.5} pb={2}>
        <Stack direction={{ sm: "row" }} justifyContent={"space-between"}>
          <Typography variant="h5" fontWeight={600}>
            Revenue
          </Typography>
          {/* <SelectInput
            formStyleProps={{ width: { xs: "100%", sm: 150 } }}
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <MenuItem value={"yearly"}>Yearly </MenuItem>
            <MenuItem value={"monthly"}>Month </MenuItem>
          </SelectInput> */}
        </Stack>
        <Box mt={3} height={{ xs: 250, md: 400 }}>
          {data?.length > 0 ? (
            <DashboardChart data={data} />
          ) : (
            <Typography
              color="black"
              fontSize={14}
              fontWeight={700}
              textAlign="center"
              padding="30px 0"
            >
              No Revenue Yet!
            </Typography>
          )}
        </Box>
      </Stack>
    </AppContainer>
  );
};

export default PlatformChart;
